module.exports = __webpack_public_path__ + "img/bandeira-china.0b2bc39d.svg";